import { c as _c } from "react/compiler-runtime";
import { RemoveMemberSuccessDescription } from "@components/remove-member-success-description";
import { isSuccessResponse } from "@context-providers/error-boundary/error-boundary-utils";
import { useToast } from "@flat-ui";
import { useSelfProjectAccess } from "@hooks/projects/use-self-project-access";
import { fetchingProjectsFlagsSelector } from "@store/projects/projects-selector";
import { removeMemberFromProject } from "@store/projects/projects-slice-thunk";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { ProjectMemberEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
/**
 * Shared logic for removing a member from a single project: tracks the event,
 * dispatches the removal, and shows a success toast. Callers own their own
 * confirmation dialog and gating (hide vs. disable), and pass tracking props.
 */
export function useRemoveMemberFromProject(t0) {
  const $ = _c(16);
  const {
    companyId,
    project,
    trackingProps,
    onRemoved
  } = t0;
  const dispatch = useAppDispatch();
  const {
    openToast
  } = useToast();
  const {
    trackEvent
  } = useTrackEvent();
  let t1;
  if ($[0] !== companyId || $[1] !== project.id) {
    t1 = {
      companyId,
      projectId: project.id
    };
    $[0] = companyId;
    $[1] = project.id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    onAccessChanged
  } = useSelfProjectAccess(t1);
  const {
    isRemovingProjectMember
  } = useAppSelector(fetchingProjectsFlagsSelector);
  let t2;
  if ($[3] !== companyId || $[4] !== dispatch || $[5] !== onAccessChanged || $[6] !== onRemoved || $[7] !== openToast || $[8] !== project.id || $[9] !== project.name || $[10] !== trackEvent || $[11] !== trackingProps) {
    t2 = async function removeMember(member) {
      trackEvent({
        name: ProjectMemberEvents.removeMember,
        props: trackingProps
      });
      const result = await dispatch(removeMemberFromProject({
        companyId,
        projectId: project.id,
        member
      }));
      if (!isSuccessResponse(result)) {
        return false;
      }
      openToast({
        title: "Member removed from project",
        message: <RemoveMemberSuccessDescription member={member} subjectType="project" entityName={project.name} />
      });
      onRemoved?.([project.id]);
      onAccessChanged({
        memberIdentity: member.identity,
        currentRole: member.role
      });
      return true;
    };
    $[3] = companyId;
    $[4] = dispatch;
    $[5] = onAccessChanged;
    $[6] = onRemoved;
    $[7] = openToast;
    $[8] = project.id;
    $[9] = project.name;
    $[10] = trackEvent;
    $[11] = trackingProps;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  const removeMember = t2;
  let t3;
  if ($[13] !== isRemovingProjectMember || $[14] !== removeMember) {
    t3 = {
      removeMember,
      isRemovingMember: isRemovingProjectMember
    };
    $[13] = isRemovingProjectMember;
    $[14] = removeMember;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  return t3;
}